import Forbidden from "@Pages/Error/Forbidden";
import { Suspense, lazy, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@Reducers/index";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

const ReviewFlows = lazy(
  () => import("../../../../components/SpaceSettings/UserAdministration/ReviewFlows/ReviewFlows"),
);
const ReviewFlowDetails = lazy(
  () => import("../../../../components/SpaceSettings/UserAdministration/ReviewFlows/ReviewFlowDetails"),
);

interface ReviewFlowsWrapperProps {
  projectId: string;
}

function ReviewFlowsWrapper({ projectId }: ReviewFlowsWrapperProps) {
  // `""` is the "nothing selected" sentinel that switches the render back to the list; every
  // non-empty value is a ReviewFlows row `_id` (`objectIdString`), so the details branch — which
  // is reached only when the value is truthy — gets a branded id with no assertion.
  const [reviewFlowId, setReviewFlowId] = useState<ObjectIdString | "">("");
  const getProjectSettingObject = useSelector((state: RootState) => state.getProjectSettingObject);

  // Derived directly from the permission object — no need for state + effect.
  const hasAccess = Boolean(getProjectSettingObject?.reviewFlow?.add?.enable);

  // Accepts the sentinel too: ReviewFlowDetails calls this with `""` to go back to the list.
  const handleReviewFlowChange = (id: ObjectIdString | "") => {
    setReviewFlowId(id);
  };

  return (
    <>
      {!reviewFlowId ? (
        <Suspense>
          {hasAccess ? (
            <ReviewFlows handleReviewFlowChange={handleReviewFlowChange} projectId={projectId} />
          ) : (
            <Forbidden />
          )}
        </Suspense>
      ) : (
        <Suspense>
          <ReviewFlowDetails
            handleReviewFlowChange={handleReviewFlowChange}
            reviewFlowId={reviewFlowId}
            projectId={projectId}
          />
        </Suspense>
      )}
    </>
  );
}

export default ReviewFlowsWrapper;
